export default  {
  bindings: {
    currentProperty: '<',
    properties: '<'
  },
  controller: 'propertySelectorController',
  template: require('../views/property.selector.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.selector.component.js